{
  "title": "如何上傳作品檔案並標記為就緒",
  "description": "上傳作品所需檔案，並在完成後將投稿標記為「就緒」以便正式提交。",
  "headings": ["你會完成什麼", "適用角色", "操作前確認", "操作步驟", "完成後", "常見問題"],
  "summary": "完成後，您的投稿檔案已上傳完成，投稿狀態為「就緒」，可以進行「正式提交」。",
  "roleNote": "參賽者",
  "prerequisites": ["已建立投稿（選擇組別與輪次）", "已加入隊伍"],
  "pathLabel": "隊伍工作區 → 我的投稿",
  "steps": [
    {
      "title": "1. 選擇要上傳的欄位",
      "description": "投稿表單的每個檔案類欄位分別對應可上傳的檔案類型與大小限制；欄位是否必填由主辦方設定。"
    },
    {
      "title": "2. 上傳檔案",
      "description": "選擇檔案後系統會直接上傳；單一檔案上限 500 MB，超過 100 MB 的檔案會自動改用分段上傳，過程對您透明。上傳時會依欄位設定檢查副檔名／類型與大小限制，不符合會立即提示錯誤。"
    },
    {
      "title": "3. 確認檔案已列出",
      "description": "上傳完成後，該檔案會出現在對應欄位下方的檔案清單中；可視需要刪除重新上傳。草稿（draft）與就緒（ready）狀態下都可以繼續新增或替換檔案，並不會因為標記就緒就被鎖住。若上傳過程中途真的失敗（而非單純尚未上傳），該欄位會明確顯示「上傳失敗，請重新上傳」的狀態，不會被誤判為只是尚未填寫；請重新選擇檔案再上傳一次即可。"
    },
    {
      "title": "4. 標記為就緒",
      "description": "所有必填欄位（含檔案與一般欄位）都完成後，點選「標記為就緒」，投稿狀態由「草稿」轉為「就緒」；如需繼續修改，也可以再點選「改回草稿」轉回可編輯狀態。"
    }
  ],
  "afterward": [
    "投稿狀態顯示為「就緒」",
    "「就緒」狀態下仍可繼續上傳或刪除檔案、修改一般欄位",
    "截止時間前可隨時在「草稿」與「就緒」間切換"
  ],
  "nextSteps": "確認內容無誤後，請見「如何正式提交作品」完成最後的正式提交（正式提交後即無法再修改或上傳檔案）。",
  "faq": [
    {
      "q": "標記為就緒後，還可以修改內容或重新上傳檔案嗎？",
      "a": "可以。「就緒」與「草稿」都屬於可編輯狀態，差別只在於「就緒」代表您認為已完成、可以正式提交；只有「正式提交」之後才會真正鎖定，無法再修改。"
    },
    {
      "q": "檔案上傳失敗，可能是什麼原因？",
      "a": "最常見的原因是檔案類型不符合該欄位允許的格式、檔案超過 500 MB 上限、或投稿已超過截止時間（截止後無法再上傳）；請依畫面上的錯誤訊息確認。 截止時間以目前輪次的投稿截止時間為準。"
    },
    {
      "q": "一定要先標記為就緒才能正式提交嗎？",
      "a": "是的，正式提交前投稿必須先處於「就緒」狀態；仍在「草稿」狀態時系統會阻擋正式提交的操作。"
    },
    {
      "q": "報名還沒截止，可以先上傳作品嗎？",
      "a": "可以，只要主辦方設定的作品繳交時間已經開始。報名與作品繳交的時間可以重疊，重疊期間競賽狀態會顯示為「報名中」，但已完成報名與團隊設定的隊伍仍然可以開始或繼續準備作品。實際的繳交截止時間以競賽頁與作品繳交頁顯示的日期為準。"
    }
  ]
}
